import React, {useRef, useState, useEffect} from 'react';
import Web3 from "web3";
import Swal  from "sweetalert2";
import { providerURL, formatDateAndtime, txAfterDone, txDone, txStart} from "../utils";
import Staking from '../abi/staking.json'

const LockTable = ({lockHistory, account, providers, updatePage}) => {
  const unlockToken = async (lockID) => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    try {
      Swal.fire({
        title: "Sure you want to unlock pTGC?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, I am sure!",
        cancelButtonText: "No, cancel it!",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-secondary"
        },
        buttonsStyling: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          await stakingContract.methods.unlock(lockID).send({
            from: account
          }).on('transactionHash', function(payload) {
            txStart();
          }).on('error', function(error) {
            Swal.fire({
              title: "Error Found",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Ok",
              showCloseButton: true,
              customClass: {
                confirmButton: "btn btn-danger"
              }
            });
          }).then(function(receipt) {
            updatePage();
            txDone()
            setTimeout(() => {
              txAfterDone()
            }, 2000)
          });
        }
      });
    } catch (error) {
      txDone();
      txAfterDone();
      Swal.fire({
        title: "Please try again",
        text: error.message,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-danger"
        }
      });
    }
  }

  const claimReward = async (lockID) => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    try {
      await stakingContract.methods.withdrawRewardLock(lockID).send({
        from: account
      }).on('transactionHash', function(payload) {
        txStart();
      }).on('error', function(error) {
        Swal.fire({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }).then(function(receipt) {
        updatePage();
        txDone()
        setTimeout(() => {
          txAfterDone()
        }, 2000)
      });
    } catch (error) {
      txDone();
      txAfterDone();
      Swal.fire({
        title: "Please try again",
        text: error.message,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-danger"
        }
      });
    }
  }

  const calculateTimeLeft = (targetDate) => {
    const difference = +new Date(targetDate) - +new Date();

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const CountdownInline = ({ endDate }) => {
    console.log("endDate =>", endDate);
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endDate));

    useEffect(() => {
        const timer = setInterval(() => {
          setTimeLeft(calculateTimeLeft(endDate));
        }, 1000);

        return () => clearInterval(timer);
      }, [endDate]);

      const { days, hours, minutes, seconds } = timeLeft;

      return (
        <div className="days f12 d-flex align-items-center text-center gap-2 flex-wrap">
          <div className="snTime mb-1"><span>{days} </span><span>D</span></div>
          <div className="snTime mb-1"><span>{hours} </span><span>H</span></div>
          <div className="snTime mb-1"><span>{minutes} </span><span>M</span></div>
          <div className="snTime mb-1"><span>{seconds} </span><span>S</span></div>
        </div>
      );
  };

  return (
  <>
  {
   lockHistory.length > 0 ?
    <>
     <section className="PTGCSEC excoSystemSec stakeSec StatsSec leftrightSecSpace">
        <div className="">
          <h2 className="good_times goldFont">Lock Info</h2>
          <div className="row">
            <div className="col-md-12">
              <div className="statsSN subcontent">
                <div className="tUpper d-lg-flex d-none">
                  <div className="twidth sr">#</div>
                  <div className="twidth">Amount</div>
                  <div className="twidth">Rewards</div>
                  <div className="twidth">Start Date</div>
                  <div className="twidth">End Date</div>
                  <div className="twidth time">Time Remaining</div>
                  <div className="twidth twidthbtn"></div>
                </div>
                {
                  lockHistory.map((item, index) => {
                    return (
                      <div className="tUpper tBottom" key={"lockHistory"+index}>
                        <div className="twidth sr"><span className="d-lg-none d-block op08 spanTable">Serial No:</span>{++index}</div>
                        <div className="twidth"><span className="d-lg-none d-block op08 spanTable">Amount: </span><div className="dollorVal dollorValRight mt-0 mb-0"><span className="val gradient-stroke-text">{parseFloat(item.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div></div>
                        <div className="twidth"><span className="d-lg-none d-block op08 spanTable">Rewards: </span><div className="dollorVal dollorValRight mt-0 mb-0"><span className="val gradient-stroke-text">{parseFloat(item.reward).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div></div>
                        <div className="twidth"><span className="d-lg-none d-block op08 spanTable">Start Date: </span>{formatDateAndtime(new Date(item.startTime * 1000))}</div>
                        <div className="twidth"><span className="d-lg-none d-block op08 spanTable">End Date: </span>{formatDateAndtime(new Date(item.endTime * 1000))}</div>
                        <div className="twidth time"><span className="d-lg-none d-block op08 spanTable">Time Remaining: </span> <CountdownInline key={item.id} endDate={item.endTime * 1000} /> </div>
                        <div className="twidth twidthbtn d-flex gap-1">
                          <div className="someBtns SRTOP  d-flex gap-2">
                            {
                              item.reward > 0.01 ?
                              <>
                                <button className="borderbtn mybtn d-flex align-items-center w-100 justify-content-between"  style={{paddingLeft: '15px'}} onClick={() => { claimReward([item.key]) }}>
                                  <span>Claim</span>
                                  <img className="img-fluid" src="./images/circle_arrow.svg" style={{width:'27px'}} />
                                </button>
                              </>
                              :
                              <>
                                <button className="borderbtn mybtn d-flex align-items-center w-100 justify-content-between disabled" disabled style={{paddingLeft: '15px'}} >
                                  <span>Claim</span>
                                  <img className="img-fluid" src="./images/circle_arrow.svg" style={{width:'27px'}} />
                                </button>
                              </>
                            }
                          </div>
                          <div className="someBtns SRTOP  d-flex gap-2">
                            <button className="borderbtn mybtn d-flex align-items-center w-100 justify-content-between"  style={{paddingLeft: '15px'}} onClick={() => { unlockToken([item.key]) }}>
                              <span>Unlock</span>
                                  <img className="img-fluid" src="./images/circle_arrow.svg" style={{width:'27px'}} />
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
    :
    <>
    </>
  }
  </>
  );
};

export default LockTable;